import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSunOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#sun_outlined_svg__a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 2.194V1.178M3.895 12.106l-.719.718M8 14.822v-1.016m4.823-10.63-.718.719M13.805 8h1.017m-2.717 4.106.718.718M1.178 8h1.016m.982-4.824.718.718m6.58 1.631a3.5 3.5 0 1 1-4.949 4.95 3.5 3.5 0 0 1 4.95-4.95"
        />
      </g>
      <defs>
        <clipPath id="sun_outlined_svg__a">
          <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSunOutlined);
export default ForwardRef;
